const PEOPLE_WITH_LINK = 'peopleWithTheLink';
const PEOPLE_IN_COMPANY = 'peopleInYourCompany';
const PEOPLE_IN_ITEM = 'peopleInThisItem';

const CAN_EDIT = 'canEdit';
const CAN_VIEW = 'canView';

export { CAN_EDIT, CAN_VIEW, PEOPLE_WITH_LINK, PEOPLE_IN_COMPANY, PEOPLE_IN_ITEM };
